import type { Connection } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteConnectionDialogProps {
  connection: Connection | null;
  /** Human-readable "from → to" label for the confirmation copy — resolved
   * by the caller, which already has both services' names loaded. */
  label: string;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Connections are immutable once created (ADR-0025 §2) — deleting is the
 * only way to change one, which is why this is the only connection dialog
 * besides "add." */
export function DeleteConnectionDialog({ connection, label, isDeleting, onCancel, onConfirm }: DeleteConnectionDialogProps) {
  return (
    <Modal open={connection !== null} title="Delete connection" onClose={onCancel}>
      <p>
        Remove the connection <strong>{label}</strong>? This only removes the declared topology — it doesn't stop
        either service.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Deleting…" : "Delete"}
        </Button>
      </div>
    </Modal>
  );
}
